import React from 'react';
import { Row, Col } from 'antd';
import { I18n } from '@aws-amplify/core';
import { DeleteOutlined } from '@ant-design/icons';
import { Description, ModalStyled, RoundedButton } from './styles';

interface DeleteModalProps {
	open: boolean;
	message: string;
	onCancel(): void;
	onConfirm(): void;
}

export function DeleteModal({ open, message, onCancel, onConfirm }: Readonly<DeleteModalProps>) {
	return (
		<ModalStyled centered width={480} footer={null} open={open} onCancel={onCancel}>
			<Row justify="center" gutter={[0, 30]}>
				<Col span={24}>
					<Row justify="center">
						<Col>
							<DeleteOutlined
								style={{
									color: '#E74150',
									fontSize: 70
								}}
							/>
						</Col>
					</Row>
				</Col>
				<Col span={18}>
					<Description>{message}</Description>
				</Col>
				<Col span={24} style={{ marginTop: 20 }}>
					<Row justify="center" gutter={[20, 0]}>
						<Col>
							<RoundedButton key="back" onClick={onCancel}>
								{I18n.get('Cancel')}
							</RoundedButton>
						</Col>
						<Col>
							<RoundedButton type="primary" onClick={onConfirm}>
								{I18n.get('Yes')}
							</RoundedButton>
						</Col>
					</Row>
				</Col>
			</Row>
		</ModalStyled>
	);
}
